export const TINYMCE_API_KEY = "3vvqo5l0z85ktcjvbmyxqvfje6cedk5mddfxi2pqdeake60d";
